import type { QueueJobStatus } from "@/admin/entities/queues";

/** Подписи статусов под счётчиками в карточке очереди */
export const statusLabels: Record<QueueJobStatus, string> = {
  delayed: "отложенные",
  waiting: "ожидают",
  active: "в работе",
  completed: "завершены",
  failed: "ошибки",
};

/**
 * Значение статуса для Bull `queue.clean()`: там ожидающие задачи называются
 * `wait`, тогда как в счётчиках и в выборке задач — `waiting`.
 */
export const cleanStatuses: { status: string; label: string }[] = [
  { status: "delayed", label: "Очистить отложенные" },
  { status: "wait", label: "Очистить ожидающие" },
  { status: "active", label: "Очистить активные" },
  { status: "completed", label: "Очистить завершённые" },
  { status: "failed", label: "Очистить упавшие" },
];

export const sortOptions: { value: string; label: string }[] = [
  { value: "delayed", label: "По отложенным" },
  { value: "waiting", label: "По ожидающим" },
  { value: "active", label: "По активным" },
  { value: "completed", label: "По завершённым" },
  { value: "failed", label: "По ошибкам" },
  { value: "name", label: "По названию" },
];

/**
 * Очередей в системе десятки, не тысячи, а фильтр и сортировка на странице
 * работают по всему списку сразу — поэтому забираем его одной страницей.
 */
export const QUEUES_PAGE_SIZE = 1000;

/** Как часто перезапрашиваем счётчики (в референсе — те же 10 секунд) */
export const QUEUES_POLL_INTERVAL = 10000;
